var eMajorsList: any = {
  "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG": [
    "Khái quát chung về hàng không dân dụng",
    "Pháp luật về hàng không dân dụng",
    // "An ninh hàng không",
    "An ninh hàng không dành cho người quản lý, nhân viên chuyên trách về an ninh hàng không, người giám sát, quản lý khai thác, điều độ và trưởng đại diện của hãng hàng không việt nam",
    "An ninh hàng không dành cho nhân viên điều hành mặt đất của hãng hàng không Việt Nam",
    "An ninh hàng không dành cho người giám sát, quản lý khai thác, điều độ, trưởng đại diện của hãng hàng không nước ngoài",
    "An ninh hàng không dành cho nhân viên điều hành mặt đất của hãng hàng không nước ngoài",
    "An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất của các đơn vị cung cấp dịch vụ hàng không tại cảng hàng không, sân bay",
    "An ninh hàng không dành cho người quản lý, nhân viên doanh nghiệp cung cấp dịch vụ khai thác nhà ga, kho hàng hóa",
    "An ninh hàng không dành cho người quản lý, nhân viên doanh nghiệp cung cấp suất ăn hàng không",
    "An ninh hàng không  dành cho người quản lý, nhân viên doanh nghiệp cung cấp dịch vụ vệ sinh tàu bay",
    "An ninh hàng không  dành cho người làm việc thường xuyên trong khu vực hạn chế",
    "An toàn hàng không",
    "Công tác khẩn nguy tại Cảng hàng không sân bay",
    // "Hàng nguy hiểm",
    "Hàng nguy hiểm dành cho người chịu trách nhiệm chuẩn bị lô hàng nguy hiểm",
    "Hàng nguy hiểm dành cho người chịu trách nhiệm tham gia vào quá trình tiếp nhận hoặc phục vụ hàng hoá, hàng bưu chính thông thường",
    "Hàng nguy hiểm dành cho người chịu trách nhiệm tiếp nhận hoặc phục vụ hàng nguy hiểm",
    "hàng nguy hiểm dành cho người chịu trách nhiệm giám sát việc phục vụ hàng hóa và hành khách, hành lý",
    "Hàng nguy hiểm dành cho người chịu trách nhiệm chất xếp hàng hóa trong nhà kho và xếp dỡ thùng mâm, xếp dỡ hàng hóa, hành lý lên xuống tàu bay",
    "Hàng nguy hiểm dành cho người chịu trách nhiệm chấp nhận hành lý của hành khách và tổ bay, kiểm soát khu vực cửa khởi hành",
    "Hàng nguy hiểm dành cho người thực hiện nhiệm vụ có tiếp xúc trực tiếp với hành khách tại sân bay",
    "Hàng nguy hiểm dành cho thành viên tổ lái",
    "Hàng nguy hiểm dành cho nhân viên điều hành khai thác bay, điều phái bay",
    "Hàng nguy hiểm dành cho tiếp viên hàng không",
    "Hàng nguy hiểm dành cho người có trách nhiệm lên kế hoạch chất xếp lên tàu bay",
    "Nhận thức về hàng nguy hiểm",
    "Yếu tố con người",
    "Phòng tránh vật thể rơi từ tàu bay (Dành cho các đối tượng ngoại trừ nhân viên vệ sinh, nhân viên phục vụ hành khách và nhân viên phục vụ hành lý trong nhà ga)",
    "Khái quát chung về hàng không dân dụng",
    "Pháp luật về hàng không dân dụng",
    //"An ninh hàng không",
    "An ninh hàng không dành cho người quản lý, nhân viên chuyên trách về an ninh hàng không, người giám sát, quản lý khai thác, điều độ và trưởng đại diện của hãng hàng không việt nam",
    "An ninh hàng không dành cho nhân viên điều hành mặt đất của hãng hàng không Việt Nam",
    "An ninh hàng không dành cho người giám sát, quản lý khai thác, điều độ, trưởng đại diện của hãng hàng không nước ngoài",
    "An ninh hàng không dành cho nhân viên điều hành mặt đất của hãng hàng không nước ngoài",
    "An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất của các đơn vị cung cấp dịch vụ hàng không tại cảng hàng không, sân bay",
    "An ninh hàng không dành cho người quản lý, nhân viên doanh nghiệp cung cấp dịch vụ khai thác nhà ga, kho hàng hóa",
    "an ninh hàng không dành cho người quản lý, nhân viên doanh nghiệp cung cấp suất ăn hàng không",
    "An ninh hàng không  dành cho người quản lý, nhân viên doanh nghiệp cung cấp dịch vụ vệ sinh tàu bay",
    "An ninh hàng không  dành cho người làm việc thường xuyên trong khu vực hạn chế",
    "An toàn hàng không",
    "Công tác khẩn nguy tại Cảng hàng không sân bay",
    //"Hàng nguy hiểm	",
    "Trường hợp thời gian nghỉ dãn cách ít hơn 24 tháng: Thời lượng như chương trình đào tạo Định kỳ",
    "Trường hợp thời gian nghỉ dãn cách trên 24 tháng hoặc đã qua thời gian định kỳ: Thời lượng như chương trình đào tạo Ban đầu.",
    "Nội dung và thời lượng như chương trình đào tạo Hàng nguy hiểm - Ban đầu.",
    "Các môn Pháp luật về hàng không dân dụng, An ninh hàng không, An toàn hàng không, Yếu tố con người",
    "Trường hợp thời gian nghỉ dãn cách ít hơn 36 tháng: Thời lượng như chương trình đào tạo Định kỳ",
    "Trường hợp thời gian nghỉ dãn cách trên 36 tháng hoặc đã qua thời gian định kỳ: Thời lượng như chương trình đào tạo Ban đầu.",
  ],
  "ĐIỀU KHIỂN XE/ MOOC BĂNG CHUYỀN": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe /mooc băng chuyền",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE Ô TÔ THÔNG THƯỜNG (Xe tải, xe bán tải, xe chở khách, nhân viên trên khu bay từ 4 đến 30 chỗ, xe cứu thương, xe dẫn tàu bay)":
    [
      "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
      "Kiểm tra",
      "Lý thuyết xe ô tô thông thường",
      "Thực hành",
    ],
  "ĐIỀU KHIỂN XE CHỞ KHÁCH TRÊN KHU BAY TỪ 30 CHỖ TRỞ LÊN": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe chở khách trên khu bay từ 30 chỗ trở lên",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE SUẤT ĂN": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe chở khách trên khu bay từ 30 chỗ trở lên",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE CẤP NƯỚC SẠCH": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe chở khách trên khu bay từ 30 chỗ trở lên",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE ĐẦU KÉO": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe chở khách trên khu bay từ 30 chỗ trở lên",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE KÉO ĐẨY TÀU BAY DÙNG CẦN KÉO ĐẨY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe kéo đẩy tàu bay không dùng cần kéo đẩy",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE KÉO ĐẨY TÀU BAY KHÔNG DÙNG CẦN KÉO ĐẨY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe chở khách trên khu bay từ 30 chỗ trở lên",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE NÂNG HÀNG": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe nâng hàng",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE XÚC NÂNG": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe xúc nâng",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE PHỤC VỤ HÀNH KHÁCH HẠN CHẾ KHẢ NĂNG DI CHUYỂN": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Thực hành",
    "Lý thuyết xe  phục vụ hành khách hạn chế khả năng di chuyển",
  ],
  "ĐIỀU KHIỂN XE THANG": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Lý thuyết xe thang ",
    "Kiểm tra",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE TRUNG CHUYỂN THÙNG HÀNG": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe trung chuyển thùng hàng",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE HÚT VỆ SINH": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe hút vệ sinh",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE  TRA NẠP NHIÊN LIỆU CHO CÁC  PHƯƠNG TIỆN TRÊN KHU BAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe tra nạp nhiên liệu cho các phương tiện hoạt động trên khu bay",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE NÂNG VẬT TƯ, HÀNG HÓA RỜI": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe nâng vật tư, hàng hóa rời",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE  CẤP ĐIỆN CHO TÀU BAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe cấp điện cho tàu bay",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE CẤP KHÍ KHỞI ĐỘNG TÀU BAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe cấp khí khởi động tàu bay",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE ĐIỀU HÒA KHÔNG KHÍ": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết xe điều hòa không khí",
    "Thực hành",
  ],
  "VẬN HÀNH THIẾT BỊ THÙNG NÂNG XE SUẤT ĂN": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết thiết bị thùng nâng xe suất ăn",
    "Thực hành",
  ],
  "VẬN HÀNH THANG KÉO ĐẨY TAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết thang kéo đẩy tay",
    "Thực hành",
  ],
  "VẬN HÀNH THIẾT BỊ CẤP ĐIỆN CHO TÀU BAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết thiết bị cấp điện cho tàu bay",
    "Thực hành",
  ],
  "VẬN HÀNH THIẾT BỊ CẤP KHÍ KHỞI ĐỘNG  TÀU BAY": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết thiết bị cấp khí khởi động tàu bay",
    "Thực hành",
  ],
  "VẬN HÀNH THIẾT BỊ ĐIỀU HÒA KHÔNG KHÍ": [
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết thiết bị điều hòa không khí",
    "Thực hành",
  ],
  "ĐIỀU KHIỂN XE/ MOOC BĂNG CHUYỀN-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE Ô TÔ THÔNG THƯỜNG-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE CHỞ KHÁCH TRÊN KHU BAY TỪ 30 CHỖ TRỞ LÊN-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE CẤP NƯỚC SẠCH-Huấn luyện thực tế": ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE ĐẦU KÉO-Huấn luyện thực tế": [
    "Thực hành",
    "Phục vụ tại tàu bay",
    "Phục vụ tại khu vực chất xếp hành lý",
    "Phục vụ tại khu vực hàng hóa",
  ],
  "ĐIỀU KHIỂN XE ĐẦU KÉO-Thực hành nâng cao": [
    "Thực hành",
    "Kéo 2-3 dolly tiếp cận xe nâng (mô hình)",
    "Lùi 02 dolly đấu nối",
    "Lùi 02 dolly tiếp cận xe nâng (mô hình)",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE KÉO ĐẨY TÀU BAY DÙNG CẦN KÉO ĐẨY-Huấn luyện thực tế": [
    " Thực hành",
    "Tàu bay thân hẹp",
    "Tàu bay thân rộng",
    "Tàu bay 747 trở lên",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE NÂNG HÀNG-Huấn luyện thực tế xe nâng dưới 14 tấn": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE NÂNG HÀNG từ  14 tấn trở lên (phục vụ Lower deck)": [
    "Lý thuyết",
    "Kiểm tra lý thuyết",
    "Thực hành",
    "Kiểm tra thực hành",
  ],
  "ĐIỀU KHIỂN XE NÂNG HÀNG-Huấn luyện thực tế (phục vụ Main deck)": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE XÚC NÂNG-Huấn luyện thực tế": ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE  PHỤC VỤ HÀNH KHÁCH HẠN CHẾ KHẢ NĂNG DI CHUYỂN-Huấn luyện thực tế":
    ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE THANG-Huấn luyện thực tế": ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE TRUNG CHUYỂN THÙNG HÀNG-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE HÚT VỆ SINH-Huấn luyện thực tế": ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE TRA NẠP NHIÊN LIỆU CHO CÁC PHƯƠNG TIỆN TRÊN KHU BAY-Huấn luyện thực tế":
    ["Thực hành", "Kiểm tra"],
  "ĐIỀU KHIỂN XE NÂNG VẬT TƯ, HÀNG HÓA RỜI-Huấn luyện thực tế ": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE  CẤP ĐIỆN CHO TÀU BAY-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE CẤP KHÍ KHỞI ĐỘNG TÀU BAY-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "ĐIỀU KHIỂN XE ĐIỀU HÒA KHÔNG KHÍ-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "VẬN HÀNH THIẾT BỊ CẤP ĐIỆN CHO TÀU BAY-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "VẬN HÀNH THIẾT BỊ CẤP KHÍ KHỞI ĐỘNG  TÀU BAY-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "VẬN HÀNH THIẾT BỊ ĐIỀU HÒA KHÔNG KHÍ-Huấn luyện thực tế": [
    "Thực hành",
    "Kiểm tra",
  ],
  "VẬN HÀNH THIẾT BỊ CHỐNG ĐUÔI TÀU BAY ĐÀO TẠO  (OJT)": [
    "Thực hành",
    "Kiểm tra",
  ],
  "QUY TRÌNH PHỤC VỤ SÂN ĐỖ": ["Lý thuyết", "Kiểm tra"],
  "CÁC NGHIỆP VỤ HỖ TRỢ ĐÀO TẠO  (OJT)": [
    "Hướng dẫn tháo lắp cần kéo đẩy tàu bay",
    "Hướng dẫn đặt/thu chèn, chóp tàu bay",
    "Hướng dẫn cảnh giới đầu cánh, wingguard",
  ],
  "NGHIỆP VỤ BẢO DƯỠNG, SỬA CHỮA PHƯƠNG TIỆN , THIẾT BỊ": [
    "Lý thuyết : Quy trình, hướng dẫn công việc bảo dưỡng sửa chữa phương tiện, thiết bị",
    "Kiểm tra",
    "Thực hành bảo dưỡng, sửa chữa phương tiện, thiết bị",
    "Kiểm tra",
  ],
  " NGHIỆP VỤ BẢO DƯỠNG, SỬA CHỮA CƠ KHÍ": [
    "Lý thuyết : Quy trình, hướng dẫn công việc bảo dưỡng sửa chữa cơ khí",
    "Kiểm tra",
    "Thực hành bảo dưỡng, sửa chữa cơ khí",
    "Kiểm tra",
  ],
  "CHUYÊN MÔN HỖ TRỢ": [
    "Sửa chữa máy gầm",
    "Sửa chữa điện, lạnh",
    "Sửa chữa thủy lực, khí nén",
    "Hướng dẫn sử dụng trạm nước sạch, hệ thống phòng",
    "cháy chữa cháy, hệ thống phát điện dự phòng",
    "Hướng dẫn sử dụng các thiết bị nâng, xe xúc nâng",
    "Hướng dẫn xử lý sự cố kỹ thuật đối với trang thiết bị",
    "Hướng dẫn sử dụng các thiết bị sửa chữa, bảo dưỡng",
    "Hướng dẫn bảo dưỡng, sửa chữa thiết bị theo tài liệu MOE",
    "Hướng dẫn ôn thi: Giấy phép sửa chữa chuyên ngành hàng không (ARS)",
    "Hướng dẫn sử dụng các phần mềm chuyên dùng trong sửa chữa, bảo dưỡng trang thiết bị",
    "Hướng dẫn quản lý kho vật tư bảo dưỡng, sửa chữa",
    "Cập nhật Quy trình, hướng dẫn công việc bảo dưỡng sửa chữa phương tiện, thiết bị",
  ],
  "ĐÀO TẠO NHẮC LẠI": [
    "Nhắc lại Quy trình, hướng dẫn công việc bảo dưỡng sửa chữa phương tiện, thiết bị",
  ],
  "NGHIỆP VỤ VỆ SINH TÀU BAY": [
    "Vệ sinh tổng thể tàu bay",
    "Lý thuyết",
    "Kiểm tra",
    "Thực hành",
    "Hướng dẫn thực hành vệ sinh khoang C",
    "Nghiệp vụ chia vật tư  ( Đào tạo OJT)",
    "Nghiệp vụ giặt là  ( Đào tạo OJT)",
    "Nghiệp vụ cấp phát/ giao nhận vật tư  ( Đào tạo OJT)",
    "Kiến thức chung về phương tiện, thiết bị chuyên ngành hàng không",
    "Kiểm tra",
    "Lý thuyết vệ sinh tàu bay",
    "Thực hành",
  ],
  "NGHIỆP VỤ GIÁM SÁT DỊCH VỤ SÂN ĐỖ": [
    "Quy định phục vụ hành khách",
    "Quy định phục vụ hành lý",
    "Quy định phục vụ hàng hóa",
    "Kiến thức dịch vụ trên không",
    "Hợp đồng PVMĐ và các thỏa thuận cung cấp chất lượng dịch vụ mặt đất",
    "Cân bằng trọng tải và hướng dẫn chất xếp cơ bản",
    "Quy trình phục vụ chuyến bay tại sân đỗ",
    "Kỹ năng giám sát, đánh giá dịch vụ chuyến bay",
    "Kỹ năng chăm sóc khách hàng",
    "Quy định vận chuyển động vật sống",
    "Thực hành",
    "Kiểm tra cuối khóa (LT: 01, TH: 01)",
  ],
  "NGHIỆP VỤ THÔNG THOẠI": [
    "Thông thoại",
    "Thực hành",
    "Kiểm tra (LT 01, TH 01)",
  ],
  "NGHIỆP VỤ PHỤC VỤ HÀNH KHÁCH CHUYẾN BAY ĐẾN": [
    "Giáo dục dịch vụ cấp nhân viên ",
    "Phục hồi và đảm bảo dịch vụ (chỉ áp dụng với NV VNA)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/ Hãng/ VIAGS ",
    "Kỹ năng chăm sóc khách hàng ",
    "Quy định phục vụ hành khách",
    "Quy định phục vụ hành lý",
    "Nghiệp vụ trả hành lý (Thực hiện khi có yêu cầu)",
    "Hướng dẫn đón và phục vụ khách đặc biệt",
    "Tiếng Anh chuyên ngành",
    "Vé hành khách ",
    "Đóng mở cửa khoang khách tàu bay từ bên ngoài ",
    "Hướng dẫn sử dụng xe lăn",
    "Quy định, hướng dẫn công việc phục vụ hành khách chuyến bay đến",
    "Thực hành",
    "Kiểm tra Tốt nghiệp lý thuyết",
    "Kiểm tra Tốt nghiệp thực hành/ Kiểm tra thực hành",
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
    "Đóng mở cửa khoang khách tàu bay từ bên ngoài (Tham chiếu Chươnng trình đào tạo nghiệp vụ tài liệu chất xếp)",
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
  "NGHIỆP VỤ PHỤC VỤ HÀNH KHÁCH RA TÀU BAY": [
    "Giáo dục dịch vụ cấp nhân viên ",
    "Phục hồi và đảm bảo dịch vụ (chỉ áp dụng với NV VNA)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/ Hãng/ VIAGS ",
    "Kỹ năng chăm sóc khách hàng ",
    "Vé hành khách ",
    "Quy định phục vụ hành lý",
    "Hệ thống kiểm soát khách tại cửa ra tàu bay ",
    "Quy định phục vụ hành khách",
    "Quy định, hướng dẫn công việc phục vụ hành khách ra tàu bay",
    "Giấy tờ du lịch",
    "Tiếng Anh chuyên ngành",
    "Đóng mở cửa khoang khách tàu bay từ bên ngoài ",
    "Hướng dẫn sử dụng xe lăn",
    "Thực hành",
    "Thực hành nghiệp vụ phục vụ hành khách ra tàu bay",
    "Thực hành phục vụ khách xe lăn",
    "Kiểm tra Tốt nghiệp lý thuyết",
    "Kiểm tra Tốt nghiệp thực hành/ Kiểm tra thực hành",
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
    "Đóng mở cửa khoang khách tàu bay từ bên ngoài (Tham chiếu Chươnng trình đào tạo nghiệp vụ tài liệu chất xếp)",
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
  "NGHIỆP VỤ LÀM THỦ TỤC HÀNH KHÁCH QUỐC NỘI": [
    "Giáo dục dịch vụ cấp nhân viên",
    "Phục hồi và đảm bảo dịch vụ ",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/ Hãng/ VIAGS ",
    "Kỹ năng chăm sóc khách hàng",
    "Vé hành khách và chứng từ thanh toán",
    "Quy định phục vụ hành lý",
    "Quy định vận chuyển động vật sống",
    "Quy định phục vụ hành khách",
    "Giấy tờ du lịch",
    "Hệ thống làm thủ tục dành cho nhân viên – VNA, xếp chỗ cho hành khách",
    "Hướng dẫn công việc làm thủ tục và công tác phối hợp các đơn vị liên quan",
    "Hướng dẫn làm thủ tục manual checkin",
    "Tiếng Anh chuyên ngành",
    "BDCS dành cho nhân viên ",
    "Kiến thức Secure Flight dành cho nhân viên checkin và nhân viên giám sát",
    "Hướng dẫn sử dụng xe lăn",
    "Nhận thức về cân bằng trọng tải",
    "Thực hành",
    "Kiểm tra Tốt nghiệp lý thuyết",
    "Kiểm tra Tốt nghiệp thực hành/ Kiểm tra thực hành",
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
    "Hệ thống làm thủ tục dành cho nhân viên VNA (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng-Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
  "XỬ LÝ ĐIỆN VĂN CHUYẾN BAY": ["Xử lý điện văn chuyến bay", "Thực hành"],
  "TELEPHONE CHECKIN": [
    "Hướng dẫn công việc",
    "Kỹ năng giao tiếp dành cho nhân viên làm thủ tục qua điện thoại",
    "Thực hành",
  ],
  "INTOWN- CHECKIN": [
    "Quy trình phục vụ",
    "Kiến thức báo cáo kế toán",
    "Thực hành",
  ],
  "HƯỚNG DẪN BÁO ĐẶT SUẤT ĂN": ["Báo đặt suất ăn", "Thực hành"],
  "NGHIỆP VỤ PHỤC VỤ HÀNH KHÁCH SỬ DỤNG PHÒNG KHÁCH BÔNG SEN": [
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng-Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
  "NGHIỆP VỤ GIÁM SÁT DỊCH VỤ CHUYẾN BAY ĐẾN": [
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
  ],
  "NGHIỆP VỤ GIÁM SÁT DỊCH VỤ CHUYẾN BAY ĐI": [
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
  ],
  "NGHIỆP VỤ PHỤC VỤ HÀNH LÝ BẤT THƯỜNG": [
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng-Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
  "NGHIỆP VỤ LÀM THỦ TỤC HÀNH KHÁCH QUỐC TẾ (CÁC HÃNG)": [
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
  ],
  "NGHIỆP VỤ LÀM THỦ TỤC HÀNH KHÁCH QUỐC TẾ (VNA)": [
    "Kiến thức chung về hàng không dân dụng (Tham chiếu Chương trình đào tạo kiến thức chung về HKDD)",
    "Hệ thống làm thủ tục dành cho nhân viên VNA (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Giáo dục dịch vụ cấp nhân viên (Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Tiêu chuẩn dịch vụ khách hàng của VNA/Hãng/VIAGS(Tham chiếu Chương trình đào tạo Quan hệ khách hàng- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Phục hồi và đảm bảo dịch vụ (Tham chiếu Chương trình đào tạo Quan hệ khách hàng-Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
    "Quy định phục vụ hành khách, hành lý (Áp dụng khi có triển khai chương trình đào tạo dịch vụ chi tiết của Vietnam Airlines- Áp dụng đào tạo phục hồi dành cho nhân viên có thời gian gián đoạn từ trên 12-24 tháng)",
  ],
};

export const getMajorsOption = (eMajors = eMajorsList) => {
  const listMajors = Object.keys(eMajors) || [];

  // const options = []

  // for (const major of listMajors) {
  //   options.push({
  //       label:major,
  //       value:major
  //   })
  // }

  return listMajors;
};

export const getMajorOptions = () => {
  const majorList = Object.keys(eMajorsList);
  return majorList.map((major: string) => ({ label: major, value: major }));
};

export const getSubjectOptions = (major: string) => {
  if (!major) return [];
  if (eMajorsList[major]) {
    return eMajorsList[major].map((course: string) => ({
      label: course,
      value: course,
    }));
  }
  return [];
};

export const getCourses = (eMajor: any, eMajors = eMajorsList) => {
  return eMajors[eMajor] || [];
};
